/* eslint-disable import/prefer-default-export */
export const STRIPE_TABLE_IDS = {
  en: process.env.REACT_APP_STRIPE_TABLE_IDS_EN,
  es: process.env.REACT_APP_STRIPE_TABLE_IDS_ES,
};
export const STRIPE_TABLE_IDS_NOTRIAL = {
  en: process.env.REACT_APP_STRIPE_TABLE_IDS_NOTRIAL_EN,
  es: process.env.REACT_APP_STRIPE_TABLE_IDS_NOTRIAL_ES,
};
